//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'
import { messageFrom } from '@/utils/api-error'
import { ACCEPT, ACCEPTED_LABEL, fileProblem, isPdf, isSpreadsheet } from '@/utils/rfi-import-files'
import RfiSheetSelect from '@/components/templates/RfiSheetSelect.vue'
import RfiPageSelect from '@/components/templates/RfiPageSelect.vue'

// Upload launcher for the AI RFI import (LSO-717). Starts a background job and hands
// control straight back to the user — reviewing/creating happens on the dedicated
// review page (/templates/imports/:jobId/review), reached from the completion
// notification or the imports dashboard, not from this modal.
export default {
  name: 'RfiImportModal',
  components: { RfiSheetSelect, RfiPageSelect },
  data() {
    return {
      phase: 'upload',
      dragOver: false,
      jobId: null,
      fileName: '',
      pendingFile: null,
      errorMessage: '',
      submitting: false,
      // Org token balance (fetched on open; unknown leaves the upload enabled — the
      // server enforces the balance regardless).
      importTokens: 0,
      tokensLoaded: false,
      accept: ACCEPT,
      acceptedLabel: ACCEPTED_LABEL
    }
  },
  computed: {
    importAvailable() {
      return !this.tokensLoaded || this.importTokens > 0
    }
  },
  methods: {
    ...mapActions({
      startImport: 'rfiImport/startImport',
      fetchImportJobs: 'rfiImport/fetchImportJobs',
      fetchImportTokens: 'rfiImport/fetchImportTokens'
    }),
    show() {
      this.resetState()
      this.$refs.modal.show()
      this.fetchImportTokens()
        .then((t) => { this.importTokens = t; this.tokensLoaded = true })
        .catch(() => {})
    },
    close() {
      this.$refs.modal.hide()
    },
    goToDashboard() {
      this.close()
      if (this.$route.path !== '/templates/imports') {
        this.$router.push('/templates/imports')
      }
    },
    resetState() {
      this.phase = 'upload'
      this.dragOver = false
      this.jobId = null
      this.fileName = ''
      this.pendingFile = null
      this.errorMessage = ''
      this.submitting = false
    },
    resetToUpload() {
      this.resetState()
    },
    onFilePicked(e) {
      const file = e.target.files && e.target.files[0]
      if (file) { this.chooseFile(file) }
      e.target.value = ''
    },
    onDrop(e) {
      this.dragOver = false
      const file = e.dataTransfer.files && e.dataTransfer.files[0]
      if (file) { this.chooseFile(file) }
    },
    // Excel uploads pause on a sheet-selection step and PDFs on a page-selection step;
    // other types (Word) go straight to import. Validated here because the `accept`
    // attribute only constrains the picker — a dragged-and-dropped file bypasses it.
    chooseFile(file) {
      if (this.submitting || !this.importAvailable) { return }
      const problem = fileProblem(file)
      if (problem) {
        this.fail(problem)
        return
      }
      this.fileName = file.name
      this.errorMessage = ''
      if (isSpreadsheet(file)) {
        this.pendingFile = file
        this.phase = 'sheets'
      } else if (isPdf(file)) {
        this.pendingFile = file
        this.phase = 'pages'
      } else {
        this.submit(file, [], [])
      }
    },
    onSheetsConfirmed(sheets) {
      this.submit(this.pendingFile, sheets, [])
    },
    onPagesConfirmed(pages) {
      this.submit(this.pendingFile, [], pages)
    },
    // Kick off the background job and hand control back to the user immediately.
    async submit(file, sheets = [], pages = []) {
      // Guard against a double-submit (double-click / repeated confirm) creating two
      // jobs for one upload. Set synchronously before the await so a second call in the
      // same tick is dropped here.
      if (this.submitting) { return }
      this.submitting = true
      this.fileName = file.name
      this.errorMessage = ''
      // Visible progress while the POST is in flight (previously the dropzone /
      // selection step just sat there looking idle).
      this.phase = 'uploading'
      try {
        const res = await this.startImport({ file, sheets, pages })
        if (!res || !res.jobId) { throw new Error('Import could not be started') }
        this.jobId = res.jobId
        this.phase = 'started'
        // Prime the watcher so it begins polling and will notify on completion. A failed
        // fetch is harmless (the watcher's next poll retries) and must not surface as an
        // unhandled rejection after the import itself succeeded.
        this.fetchImportJobs().catch(() => {})
      } catch (err) {
        this.fail(this.messageFrom(err, 'The file could not be imported.'))
      } finally {
        this.submitting = false
      }
    },
    onHidden() {
      // The job runs in the background; closing the modal must NOT discard it.
      this.resetState()
    },
    fail(message) {
      this.errorMessage = message
      this.phase = 'error'
    },
    messageFrom(err, fallback) {
      return messageFrom(err, fallback)
    }
  }
}
